import customAxios from "../serverCall";

// const AuthService = () => {
const getUsers = async (body) => {
  const response = await customAxios.post(`/admin/users`, body);

  return response;
};

// const AuthService = () => {
const activationUser = async (body) => {
  const response = await customAxios.post(`admin/user/activation`, body);

  return response;
};

// const AuthService = () => {
const getReports = async (body) => {
  const response = await customAxios.post(`/admin/reports`, body);

  return response;
};

const UserService = {
  getUsers,
  activationUser,
  getReports,
};

export default UserService;
